var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"lg":"8"}},[_c('v-divider'),_vm._v(" "),_c(_setup.PackagesList)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }